import script from "./ChallanRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./ChallanRegister.vue?vue&type=script&setup=true&lang=js"

import "./ChallanRegister.vue?vue&type=style&index=0&id=edf9b93a&lang=css"

const __exports__ = script;

export default __exports__